// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19OvB","left":"styles_left__1jU3X","desktopActions":"styles_desktopActions__123Fg","title":"styles_title__3KozR"};